module.exports = "/static/assets/be25fca420a7f95f05e8b87530324c9a.png";